// extracted by mini-css-extract-plugin
module.exports = {"root":"ToggleSwitch_root__3-2wz","switch":"ToggleSwitch_switch__J114f","slider":"ToggleSwitch_slider__2ai7f","round":"ToggleSwitch_round__3adBw"};